import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import AdminWrapper from "../../../components/AdminWrapper";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { GetAdmin } from "../../../redux/reducer/GetAdminDetail";
import MapIcon from "@mui/icons-material/Map";
import {
  AcceptProperty,
  RejectProperty,
} from "../../../redux/reducer/AcceptPropertyAdmin";
import {
  Box,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Chip,
  Avatar,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Divider,
  CircularProgress,
  Card,
  CardContent,
  CardMedia,
  Tooltip,
  Tab,
  Tabs,
  Collapse,
  Skeleton,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  Search,
  Visibility,
  CheckCircle,
  Close,
  Download,
  Refresh,
  Business,
  LocationOn,
  ExpandMore,
  ExpandLess,
  Apartment,
  ThumbUp,
  ThumbDown,
  HourglassEmpty,
  Email,
  Phone,
  Person,
  MeetingRoom,
  Bathroom,
  Kitchen,
  Layers,
  ZoomIn,
  Image as ImageIcon,
  Cancel,
  Block,
  UploadFile,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import ImageZoomModal from "../../../components/ImageZoomModal";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BuildIcon from "@mui/icons-material/Build";
import DeleteIcon from "@mui/icons-material/Delete";
import SecurityIcon from "@mui/icons-material/Security";
import GroupIcon from "@mui/icons-material/Group";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EventIcon from "@mui/icons-material/Event";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { getChargeAmounts } from "../../../utils/chargeHelper";
import { resolveLatePolicy, describeLatePolicy } from "../../../utils/latePolicy";
import {
  Bathtub as BathtubIcon,
  Pool as PoolIcon,
  FitnessCenter as FitnessCenterIcon,
  Wifi as WifiIcon,
  LocalParking as LocalParkingIcon,
  Elevator as ElevatorIcon,
  Weekend as WeekendIcon,
  Pets as PetsIcon,
  Roofing as RoofingIcon,
  FireExtinguisher as FireExtinguisherIcon,
  LocalHospital as LocalHospitalIcon,
  Balcony as BalconyIcon,
  Alarm as AlarmIcon,
} from "@mui/icons-material";
const PropertyManagement = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const open = useSelector((state) => state.sidebar.open);
  const { loading, GetAdminDetail } = useSelector(
    (state) => state.getAdminDetail
  );
  const stats = GetAdminDetail;

  // Initialize state from URL params
  const [searchQuery, setSearchQuery] = useState(
    searchParams.get("search") || ""
  );
  const [activeTab, setActiveTab] = useState(
    parseInt(searchParams.get("tab")) || 0
  );
  const [expandedRows, setExpandedRows] = useState(() => {
    const expanded = searchParams.get("expanded");
    return expanded ? JSON.parse(expanded) : {};
  });
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [rejectDialog, setRejectDialog] = useState({ open: false, flat: null });
  const [rejectReason, setRejectReason] = useState("");
  const [flatSearchQuery, setFlatSearchQuery] = useState(() => {
    const flatSearch = searchParams.get("flatSearch");
    return flatSearch ? JSON.parse(flatSearch) : {};
  });
  const [signatureIssue, setSignatureIssue] = useState(false);
  const [showAllAmenities, setShowAllAmenities] = useState(false);
  console.log(activeTab, "activeTab");

  // Update URL params when state changes
  const updateURLParams = useCallback(
    (updates) => {
      const newParams = new URLSearchParams(searchParams);
      Object.entries(updates).forEach(([key, value]) => {
        if (value && value !== "" && value !== "0" && value !== "{}") {
          if (typeof value === "object") {
            const jsonStr = JSON.stringify(value);
            if (jsonStr !== "{}") {
              newParams.set(key, jsonStr);
            } else {
              newParams.delete(key);
            }
          } else {
            newParams.set(key, value);
          }
        } else {
          newParams.delete(key);
        }
      });
      setSearchParams(newParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  // Handle search change
  const handleSearchChange = (value) => {
    setSearchQuery(value);
    updateURLParams({ search: value });
  };

  // Handle tab change
  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
    updateURLParams({ tab: newValue.toString() });
  };

  // Handle flat search change
  const handleFlatSearchChange = (ownerEmail, value) => {
    const newFlatSearch = { ...flatSearchQuery, [ownerEmail]: value };
    if (!value) delete newFlatSearch[ownerEmail];
    setFlatSearchQuery(newFlatSearch);
    updateURLParams({ flatSearch: newFlatSearch });
  };

  // Handle expand toggle
  const handleExpandToggle = (id) => {
    const newExpanded = { ...expandedRows, [id]: !expandedRows[id] };
    if (!newExpanded[id]) delete newExpanded[id];
    setExpandedRows(newExpanded);
    updateURLParams({ expanded: newExpanded });
  };

  useEffect(() => {
    dispatch(GetAdmin());
  }, [dispatch]);

  const properties = stats?.property_detail || [];
  const landlords = stats?.landlord_detail || [];

  // Create a lookup map for landlord info by email
  const landlordInfoByEmail = landlords.reduce((acc, landlord) => {
    const email = landlord.email || "";
    if (email) {
      acc[email] = {
        name:
          landlord.name ||
          landlord.ownerName ||
          landlord.owner_name ||
          landlord.userName ||
          "",
        fatherName: landlord.fatherName || landlord.father_name || "",
        contact:
          landlord.contactNumber ||
          landlord.contact ||
          landlord.phone ||
          landlord.mobile ||
          "",
        signature: landlord.signature || "",
        cnicFront: landlord.cnicFront || "",
        cnicBack: landlord.cnicBack || "",
        profilePhoto: landlord.profilePhoto || "",
      };
    }
    return acc;
  }, {});

  // Helper to get flats from property (handles both old and new API structure)
  const getFlats = (property) =>
    property.propertyDetail || property.flats || [];

  // Group properties by owner email
  const groupedByOwner = properties.reduce((acc, property) => {
    const email = property.email || "unknown";
    const landlordInfo = landlordInfoByEmail[email] || {};
    if (!acc[email]) {
      acc[email] = {
        email,
        ownerName:
          property.ownerName ||
          property.owner_name ||
          property.name ||
          property.userName ||
          property.user_name ||
          landlordInfo.name ||
          "",
        fatherName:
          property.fatherName ||
          property.father_name ||
          landlordInfo.fatherName ||
          "",
        contactNumber:
          property.contactNumber ||
          property.contact ||
          property.phone ||
          property.mobile ||
          landlordInfo.contact ||
          "",
        signature: landlordInfo.signature || "",
        cnicFront: landlordInfo.cnicFront || "",
        cnicBack: landlordInfo.cnicBack || "",
        profilePhoto: landlordInfo.profilePhoto || "",
        properties: [],
      };
    }
    // Update owner name if current property has it and previous didn't
    if (!acc[email].ownerName) {
      const newName =
        property.ownerName ||
        property.owner_name ||
        property.name ||
        property.userName ||
        property.user_name ||
        landlordInfo.name;
      if (newName) acc[email].ownerName = newName;
    }
    // Update father name if current property has it and previous didn't
    if (!acc[email].fatherName) {
      const newFatherName =
        property.fatherName || property.father_name || landlordInfo.fatherName;
      if (newFatherName) acc[email].fatherName = newFatherName;
    }
    // Update contact if current property has it and previous didn't
    if (!acc[email].contactNumber) {
      const newContact =
        property.contactNumber ||
        property.contact ||
        property.phone ||
        property.mobile ||
        landlordInfo.contact;
      if (newContact) acc[email].contactNumber = newContact;
    }
    acc[email].properties.push(property);
    return acc;
  }, {});

  const ownersList = Object.values(groupedByOwner);

  // Helper to check flat status
  const getFlatStatus = (flat) => {
    if (flat.is_rejected || flat.isRejected || flat.status === "rejected")
      return "rejected";
    if (flat.is_approved || flat.isApproved || flat.status === "accepted")
      return "approved";
    return "pending";
  };

  // Count owners with pending properties
  const ownersWithPending = ownersList.filter((owner) =>
    owner.properties.some((p) => {
      const flats = getFlats(p);
      return flats.some((f) => getFlatStatus(f) === "pending");
    })
  ).length;

  // Count total owners
  const totalOwners = ownersList.length;

  // Count total pending flats
  const totalPendingFlats = properties.reduce((count, property) => {
    const flats = getFlats(property);
    return count + flats.filter((f) => getFlatStatus(f) === "pending").length;
  }, 0);

  // Count total rejected flats
  const totalRejectedFlats = properties.reduce((count, property) => {
    const flats = getFlats(property);
    return count + flats.filter((f) => getFlatStatus(f) === "rejected").length;
  }, 0);

  // Helper function to check if a flat matches the search query
  const flatMatchesSearch = (flat, property, searchLower) => {
    if (!searchLower) return true;
    const name = (flat.flatName || flat.flat_name || "").toLowerCase();
    const addr = (
      flat.flatAddress ||
      flat.propertyAddress ||
      property?.address ||
      ""
    ).toLowerCase();
    const city = (flat.city || property?.city || "").toLowerCase();
    const rent = String(flat.flatRent || flat.rent || "");
    const floor = String(flat.flatFloor || flat.floor || "");
    const rooms = String(flat.flatRooms || flat.rooms || "");
    const status = getFlatStatus(flat);

    return (
      name.includes(searchLower) ||
      addr.includes(searchLower) ||
      city.includes(searchLower) ||
      rent.includes(searchLower) ||
      floor.includes(searchLower) ||
      rooms.includes(searchLower) ||
      status.includes(searchLower)
    );
  };

  // Helper function to get filtered flats for a property
  const getFilteredFlats = (property, searchLower) => {
    const flats = getFlats(property);
    if (!searchLower) return flats;
    return flats.filter((flat) =>
      flatMatchesSearch(flat, property, searchLower)
    );
  };

  // Filter owners based on search (only owner name and email) and tab
  const filteredOwners = ownersList.filter((owner) => {
    const searchLower = searchQuery.toLowerCase();

    // Main search only checks owner name and email
    const matchesSearch =
      !searchLower ||
      owner.ownerName.toLowerCase().includes(searchLower) ||
      owner.email.toLowerCase().includes(searchLower);

    // Tab filtering
    if (activeTab === 1) {
      // Pending tab - owners with pending flats
      const hasPending = owner.properties.some((p) => {
        const flats = getFlats(p);
        return flats.some((f) => getFlatStatus(f) === "pending");
      });
      return matchesSearch && hasPending;
    } else if (activeTab === 2) {
      // Approved tab - owners with approved flats
      const hasApproved = owner.properties.some((p) => {
        const flats = getFlats(p);
        return flats.some((f) => getFlatStatus(f) === "approved");
      });
      return matchesSearch && hasApproved;
    } else if (activeTab === 3) {
      // Rejected tab - owners with rejected flats
      const hasRejected = owner.properties.some((p) => {
        const flats = getFlats(p);
        return flats.some((f) => getFlatStatus(f) === "rejected");
      });
      return matchesSearch && hasRejected;
    } else if (activeTab === 4) {
      // Rejected tab - owners with rejected flats
      const hasRejected = owner.properties.some((p) => {
        const flats = getFlats(p);
        return flats.some((f) => f.is_rent == 1);
      });
      return matchesSearch && hasRejected;
    }

    return matchesSearch;
  });

  // Sort owners: those with pending first, then approved, then rejected
  const sortedOwners = [...filteredOwners].sort((a, b) => {
    const hasPendingA = a.properties.some((p) => {
      const flats = getFlats(p);
      return flats.some((f) => getFlatStatus(f) === "pending");
    });
    const hasPendingB = b.properties.some((p) => {
      const flats = getFlats(p);
      return flats.some((f) => getFlatStatus(f) === "pending");
    });

    if (hasPendingA && !hasPendingB) return -1;
    if (!hasPendingA && hasPendingB) return 1;
    return 0;
  });
  console.log(sortedOwners, "sortedOwners");

  const handleApproveFlat = async (flat) => {
    const flatName = flat.flatName || flat.flat_name || "this flat";
    const result = await Swal.fire({
      title: "Approve Property?",
      text: `Are you sure you want to approve "${flatName}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#22c55e",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Yes, Approve",
    });

    if (result.isConfirmed) {
      setActionLoading(flat._id);
      dispatch(AcceptProperty(flat._id))
        .unwrap()
        .then(() => {
          toast.success("Property approved successfully!", { autoClose: 2000 });
          dispatch(GetAdmin());
        })
        .catch((error) => {
          toast.error("Failed to approve property");
        })
        .finally(() => {
          setActionLoading(null);
        });
    }
  };

  const handleOpenRejectDialog = (flat) => {
    setRejectDialog({ open: true, flat });
    setRejectReason("");
  };

  const handleCloseRejectDialog = () => {
    setRejectDialog({ open: false, flat: null });
    setRejectReason("");
    setSignatureIssue(false);
  };

  const handleRejectFlat = async () => {
    if (!rejectDialog.flat) return;

    const flat = rejectDialog.flat;
    const flatName = flat.flatName || flat.flat_name || "this flat";

    if (!rejectReason.trim()) {
      toast.error("Please provide a reason for rejection");
      return;
    }

    setActionLoading(flat._id);
    handleCloseRejectDialog();

    dispatch(
      RejectProperty({
        id: flat._id,
        reason: rejectReason,
        is_editable: signatureIssue,
      })
    )
      .unwrap()
      .then(() => {
        toast.success(`"${flatName}" has been rejected`, { autoClose: 2000 });
        dispatch(GetAdmin());
        setSignatureIssue(false);
      })
      .catch((error) => {
        toast.error("Failed to reject property");
      })
      .finally(() => {
        setActionLoading(null);
      });
  };

  const handleViewImages = (images) => {
    setSelectedImages(images);
    setImageModalOpen(true);
  };

  const handleViewPropertyDetails = (property, owner) => {
    setSelectedProperty({ ...property, ...owner });
    setDetailsOpen(true);
  };

  // Loading Skeleton Component
  const LoadingSkeleton = () => (
    <>
      {/* Header Skeleton */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box>
          <Skeleton variant="text" width={250} height={40} />
          <Skeleton variant="text" width={180} height={20} />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Skeleton variant="rounded" width={100} height={36} />
          <Skeleton variant="rounded" width={100} height={36} />
        </Box>
      </Box>

      {/* Stats Cards Skeleton */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={6} sm={3} key={i}>
            <Card sx={{ borderRadius: 2 }}>
              <CardContent sx={{ textAlign: "center", py: 2 }}>
                <Skeleton
                  variant="text"
                  width={60}
                  height={50}
                  sx={{ mx: "auto" }}
                />
                <Skeleton
                  variant="text"
                  width={80}
                  height={20}
                  sx={{ mx: "auto" }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Tabs Skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={48}
        sx={{ mb: 2, borderRadius: 2 }}
      />

      {/* Search Skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={56}
        sx={{ mb: 3, borderRadius: 2 }}
      />

      {/* Owner Cards Skeleton */}
      {[1, 2, 3].map((i) => (
        <Paper key={i} sx={{ mb: 3, borderRadius: 2, overflow: "hidden" }}>
          <Box sx={{ p: 2.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Skeleton variant="circular" width={60} height={60} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={200} height={32} />
                <Skeleton variant="text" width={150} height={20} />
                <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                  <Skeleton variant="rounded" width={80} height={24} />
                  <Skeleton variant="rounded" width={60} height={24} />
                  <Skeleton variant="rounded" width={70} height={24} />
                </Box>
              </Box>
              <Skeleton variant="rounded" width={120} height={36} />
            </Box>
            <Skeleton
              variant="rounded"
              width={200}
              height={50}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        </Paper>
      ))}
    </>
  );

  return (
    <>
      <AdminWrapper />
      <Box
        sx={{
          ml: { xs: 0, md: open ? "260px" : "65px" },
          transition: "margin 0.3s ease",
          minHeight: "100vh",
          bgcolor: "#f8fafc",
          p: { xs: 2, md: 3 },
          pt: { xs: 10, md: 11 },
        }}
      >
        {loading ? (
          <LoadingSkeleton />
        ) : (
          <>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, color: "#1e293b" }}
                >
                  Property Management
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Review and approve property listings
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="outlined"
                  startIcon={<Refresh />}
                  onClick={() => dispatch(GetAdmin())}
                  sx={{ borderColor: "#e5e7eb", color: "#64748b" }}
                >
                  Refresh
                </Button>
                <Button
                  variant="contained"
                  startIcon={<Download />}
                  sx={{ bgcolor: "#e94560", "&:hover": { bgcolor: "#d13652" } }}
                >
                  Export
                </Button>
              </Box>
            </Box>

            {/* Stats Cards */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={6} sm={3}>
                <Card sx={{ borderRadius: 2, border: "1px solid #e5e7eb" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: 700, color: "#6366f1" }}
                    >
                      {totalOwners}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Owners
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Card sx={{ borderRadius: 2, border: "1px solid #e5e7eb" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: 700, color: "#e94560" }}
                    >
                      {properties.length}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Properties
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Card
                  sx={{
                    borderRadius: 2,
                    border: "1px solid #fcd34d",
                    bgcolor: ownersWithPending > 0 ? "#fffbeb" : "white",
                  }}
                >
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: 700, color: "#d97706" }}
                    >
                      {ownersWithPending}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Owners with Pending
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Card sx={{ borderRadius: 2, border: "1px solid #fbbf24" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: 700, color: "#b45309" }}
                    >
                      {totalPendingFlats}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Pending Flats
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Tabs */}
            <Paper sx={{ mb: 2, borderRadius: 2 }}>
              <Tabs
                value={activeTab}
                onChange={(e, newValue) => handleTabChange(newValue)}
                sx={{
                  borderBottom: "1px solid #e5e7eb",
                  "& .MuiTab-root": { textTransform: "none", fontWeight: 500 },
                }}
              >
                <Tab label={`All Owners (${totalOwners})`} />
                <Tab
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      Pending
                      {totalPendingFlats > 0 && (
                        <Chip
                          label={totalPendingFlats}
                          size="small"
                          sx={{
                            bgcolor: "#fbbf24",
                            color: "#78350f",
                            height: 20,
                            fontSize: 12,
                          }}
                        />
                      )}
                    </Box>
                  }
                />
                <Tab label="Approved" />
                <Tab
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      Rejected
                      {totalRejectedFlats > 0 && (
                        <Chip
                          label={totalRejectedFlats}
                          size="small"
                          sx={{
                            bgcolor: "#ef4444",
                            color: "white",
                            height: 20,
                            fontSize: 12,
                          }}
                        />
                      )}
                    </Box>
                  }
                />
                <Tab label="Rented" />
              </Tabs>
            </Paper>

            {/* Search */}
            <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by owner name or email..."
                value={searchQuery}
                onChange={(e) => handleSearchChange(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: "#9ca3af" }} />
                    </InputAdornment>
                  ),
                  endAdornment: searchQuery && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => handleSearchChange("")}
                      >
                        <Close sx={{ fontSize: 18 }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Paper>

            {/* Owners List */}
            {sortedOwners.length === 0 ? (
              <Paper sx={{ p: 6, textAlign: "center", borderRadius: 2 }}>
                <Person sx={{ fontSize: 60, color: "#e5e7eb", mb: 2 }} />
                <Typography variant="h6" color="text.secondary">
                  No owners found
                </Typography>
              </Paper>
            ) : (
              sortedOwners.map((owner) => {
                // Calculate owner stats
                const ownerTotalFlats = owner.properties.reduce(
                  (count, p) => count + getFlats(p).length,
                  0
                );
                const ownerPendingFlats = owner.properties.reduce(
                  (count, p) => {
                    const flats = getFlats(p);
                    return (
                      count +
                      flats.filter(
                        (f) => !f.is_approved && !f.isApproved && !f.is_rejected
                      ).length
                    );
                  },
                  0
                );
                const ownerRejectedFlats = owner.properties.reduce(
                  (count, p) => {
                    const flats = getFlats(p);
                    return count + flats.filter((f) => f.is_rejected).length;
                  },
                  0
                );
                const ownerApprovedFlats =
                  ownerTotalFlats - ownerPendingFlats - ownerRejectedFlats;
                const ownerRentedFlats = owner.properties.reduce((count, p) => {
                  const flats = getFlats(p);
                  return count + flats.filter((f) => f.is_rent == 1).length;
                }, 0);

                const ownerHasPending = ownerPendingFlats > 0;

                return (
                  <Paper
                    key={owner.email}
                    sx={{
                      mb: 3,
                      borderRadius: 2,
                      overflow: "hidden",
                      border: ownerHasPending
                        ? "2px solid #fcd34d"
                        : "1px solid #e5e7eb",
                    }}
                  >
                    {/* Owner Header */}
                    <Box
                      sx={{
                        p: 2.5,
                        bgcolor: ownerHasPending ? "#fffbeb" : "white",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      {/* Owner Info Row */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          mb: 2,
                        }}
                      >
                        {console.log(owner, "ooooooooooo")}
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Avatar
                            src={owner?.profilePhoto}
                            sx={{
                              bgcolor: ownerHasPending ? "#fbbf24" : "#6366f1",
                              width: 60,
                              height: 60,
                            }}
                          >
                            <Person
                              sx={{
                                color: ownerHasPending ? "#78350f" : "white",
                                fontSize: 32,
                              }}
                            />
                          </Avatar>
                          <Box>
                            <Typography
                              variant="h5"
                              sx={{
                                fontWeight: 700,
                                color: "#1e293b",
                                mb: 0.5,
                              }}
                            >
                              {owner?.ownerName ||
                                owner?.email?.split("@")[0] ||
                                "Unknown Owner"}
                              {owner?.fatherName && (
                                <Typography
                                  component="span"
                                  variant="h5"
                                  sx={{
                                    ml: 1,
                                    fontWeight: 700,
                                    color: "#1e293b",
                                    mb: 0.5,
                                  }}
                                >
                                  s/o {owner.fatherName}
                                </Typography>
                              )}
                            </Typography>
                            {/* Email */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                mb: 1,
                              }}
                            >
                              <Email sx={{ fontSize: 16, color: "#6366f1" }} />
                              <Typography
                                variant="body2"
                                sx={{ color: "#475569", fontWeight: 500 }}
                              >
                                {owner.email || "N/A"}
                              </Typography>
                            </Box>
                            {/* Stats Chips */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flexWrap: "wrap",
                              }}
                            >
                              <Chip
                                icon={<Business sx={{ fontSize: 14 }} />}
                                label={`${owner.properties.length} ${
                                  owner.properties.length === 1
                                    ? "Property"
                                    : "Properties"
                                }`}
                                size="small"
                                sx={{
                                  bgcolor: "#e0e7ff",
                                  color: "#3730a3",
                                  "& .MuiChip-icon": { color: "inherit" },
                                }}
                              />
                              <Chip
                                icon={<Apartment sx={{ fontSize: 14 }} />}
                                label={`${ownerTotalFlats} Flats`}
                                size="small"
                                sx={{
                                  bgcolor: "#f3e8ff",
                                  color: "#7c3aed",
                                  "& .MuiChip-icon": { color: "inherit" },
                                }}
                              />
                              {ownerPendingFlats > 0 && (
                                <Chip
                                  icon={
                                    <HourglassEmpty sx={{ fontSize: 14 }} />
                                  }
                                  label={`${ownerPendingFlats} Pending`}
                                  size="small"
                                  sx={{
                                    bgcolor: "#fbbf24",
                                    color: "#78350f",
                                    "& .MuiChip-icon": { color: "inherit" },
                                  }}
                                />
                              )}
                              {ownerApprovedFlats > 0 && (
                                <Chip
                                  icon={<CheckCircle sx={{ fontSize: 14 }} />}
                                  label={`${ownerApprovedFlats} Approved`}
                                  size="small"
                                  sx={{
                                    bgcolor: "#dcfce7",
                                    color: "#166534",
                                    "& .MuiChip-icon": { color: "inherit" },
                                  }}
                                />
                              )}
                              {ownerRejectedFlats > 0 && (
                                <Chip
                                  // icon={<CheckCircle sx={{ fontSize: 14 }} />}
                                  label={`${ownerRejectedFlats} Rejected`}
                                  size="small"
                                  sx={{
                                    bgcolor: "#dcfce7",
                                    color: "red",
                                    "& .MuiChip-icon": { color: "inherit" },
                                  }}
                                />
                              )}
                              {ownerRentedFlats > 0 && (
                                <Chip
                                  // icon={<CheckCircle sx={{ fontSize: 14 }} />}
                                  label={`${ownerRentedFlats} Rented`}
                                  size="small"
                                  sx={{
                                    bgcolor: "#dcfce7",
                                    color: "green",
                                    "& .MuiChip-icon": { color: "inherit" },
                                  }}
                                />
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Button
                            size="small"
                            variant={ownerHasPending ? "contained" : "outlined"}
                            endIcon={
                              expandedRows[owner.email] ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              )
                            }
                            onClick={() => handleExpandToggle(owner.email)}
                            sx={
                              ownerHasPending
                                ? {
                                    bgcolor: "#e94560",
                                    "&:hover": { bgcolor: "#d13652" },
                                  }
                                : { borderColor: "#e5e7eb" }
                            }
                          >
                            {expandedRows[owner.email] ? "Hide" : "View"}{" "}
                            Properties
                          </Button>
                        </Box>
                      </Box>

                      {/* Contact Number */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          p: 1.5,
                          bgcolor: "#f8fafc",
                          borderRadius: 1,
                          maxWidth: 300,
                        }}
                      >
                        <Phone sx={{ fontSize: 18, color: "#22c55e" }} />
                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            Contact Number
                          </Typography>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {owner.contactNumber || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Expanded Properties */}
                    <Collapse in={expandedRows[owner.email]}>
                      <Box sx={{ p: 2, bgcolor: "#f8fafc" }}>
                        {/* Flat Search */}
                        <Paper sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Search flats by name, address, rent, status (pending/approved)..."
                            value={flatSearchQuery[owner.email] || ""}
                            onChange={(e) =>
                              handleFlatSearchChange(
                                owner.email,
                                e.target.value
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Search sx={{ color: "#9ca3af" }} />
                                </InputAdornment>
                              ),
                              endAdornment: flatSearchQuery[owner.email] && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleFlatSearchChange(owner.email, "")
                                    }
                                  >
                                    <Close sx={{ fontSize: 18 }} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Paper>
                        {/* Filter and Sort properties: pending first */}
                        {(() => {
                          const localSearchLower = (
                            flatSearchQuery[owner.email] || ""
                          ).toLowerCase();

                          // Filter properties that have matching flats (only using inner search)
                          const filteredProperties = owner.properties.filter(
                            (p) => {
                              if (!localSearchLower) return true;
                              const matchingFlats = getFilteredFlats(
                                p,
                                localSearchLower
                              );
                              return matchingFlats.length > 0;
                            }
                          );

                          if (filteredProperties.length === 0) {
                            return (
                              <Box sx={{ textAlign: "center", py: 4 }}>
                                <Search
                                  sx={{ fontSize: 48, color: "#cbd5e1", mb: 1 }}
                                />
                                <Typography color="text.secondary">
                                  No properties found{" "}
                                  {localSearchLower
                                    ? `matching "${
                                        flatSearchQuery[owner.email]
                                      }"`
                                    : ""}
                                </Typography>
                              </Box>
                            );
                          }

                          return filteredProperties
                            .sort((a, b) => {
                              const aFlats = localSearchLower
                                ? getFilteredFlats(a, localSearchLower)
                                : getFlats(a);
                              const bFlats = localSearchLower
                                ? getFilteredFlats(b, localSearchLower)
                                : getFlats(b);
                              const aPending = aFlats.some(
                                (f) => !f.is_approved && !f.isApproved
                              );
                              const bPending = bFlats.some(
                                (f) => !f.is_approved && !f.isApproved
                              );
                              if (aPending && !bPending) return -1;
                              if (!aPending && bPending) return 1;
                              return 0;
                            })
                            .filter((ee) =>
                              activeTab == 4
                                ? ee.propertyDetail[0]?.is_rent == 1
                                : activeTab == 3
                                ? ee.propertyDetail[0]?.is_rejected
                                : activeTab == 2
                                ? ee.propertyDetail[0]?.is_approved
                                : activeTab == 1
                                ? !ee.propertyDetail[0]?.is_approved &&
                                  !ee.propertyDetail[0]?.is_rejected
                                : ee
                            )
                            .map((property, propIndex) => {
                              console.log(property, "property");

                              const localSearchLower = (
                                flatSearchQuery[owner.email] || ""
                              ).toLowerCase();
                              const flats = localSearchLower
                                ? getFilteredFlats(property, localSearchLower)
                                : getFlats(property);
                              const firstFlat = flats[0] || {};
                              const propertyName =
                                firstFlat.flatName ||
                                firstFlat.flat_name ||
                                property.propertyName ||
                                "Property";
                              const propertyRent =
                                firstFlat.flatRent || firstFlat.rent || 0;
                              const address =
                                firstFlat.propertyAddress ||
                                firstFlat.flatAddress ||
                                property.address ||
                                "";
                              const city =
                                firstFlat.city || property.city || "";
                              const propertyPending = flats.filter(
                                (f) =>
                                  !f.is_approved &&
                                  !f.isApproved &&
                                  !f.is_rejected
                              ).length;
                              const propertyApproved = flats.filter(
                                (f) => f.is_approved || f.isApproved
                              ).length;
                              const propertyRejected = flats.filter(
                                (f) => f.is_rejected
                              ).length;
                              const propertyHasPending = propertyPending > 0;

                              return (
                                <Paper
                                  key={property._id || propIndex}
                                  sx={{
                                    mb: 2,
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    border: propertyHasPending
                                      ? "1px solid #fcd34d"
                                      : "1px solid #e5e7eb",
                                  }}
                                >
                                  {/* Property Header */}
                                  <Box
                                    sx={{
                                      p: 2,
                                      bgcolor: propertyHasPending
                                        ? "#fffbeb"
                                        : "white",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      gap: 1,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        flex: 1,
                                      }}
                                    >
                                      <Avatar
                                        sx={{
                                          bgcolor: propertyHasPending
                                            ? "#fef3c7"
                                            : "#e0e7ff",
                                          width: 48,
                                          height: 48,
                                        }}
                                      >
                                        <Apartment
                                          sx={{
                                            color: propertyHasPending
                                              ? "#d97706"
                                              : "#6366f1",
                                            fontSize: 24,
                                          }}
                                        />
                                      </Avatar>
                                      <Box sx={{ flex: 1 }}>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          <Typography
                                            variant="subtitle1"
                                            sx={{
                                              fontWeight: 600,
                                              color: "#1e293b",
                                            }}
                                          >
                                            {propertyName}
                                          </Typography>
                                          <Chip
                                            // icon={
                                            //   <AttachMoney
                                            //     sx={{ fontSize: 14 }}
                                            //   />
                                            // }
                                            label={`Rs. ${
                                              propertyRent?.toLocaleString() ||
                                              "N/A"
                                            }`}
                                            size="small"
                                            sx={{
                                              bgcolor: "#dcfce7",
                                              color: "#166534",
                                              fontWeight: 600,
                                              "& .MuiChip-icon": {
                                                color: "inherit",
                                              },
                                            }}
                                          />
                                          {propertyPending > 0 && (
                                            <Chip
                                              label={`Pending`}
                                              size="small"
                                              sx={{
                                                bgcolor: "#fef3c7",
                                                color: "#92400e",
                                              }}
                                            />
                                          )}
                                          {propertyRejected > 0 && (
                                            <Chip
                                              label={`Rejected`}
                                              size="small"
                                              sx={{
                                                bgcolor: "red",
                                                color: "#ffffff",
                                              }}
                                            />
                                          )}
                                          {propertyApproved > 0 && (
                                            <Chip
                                              label={`Approved`}
                                              size="small"
                                              sx={{
                                                bgcolor: "#dcfce7",
                                                color: "#166534",
                                              }}
                                            />
                                          )}
                                        </Box>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            mt: 0.5,
                                          }}
                                        >
                                          <LocationOn
                                            sx={{
                                              fontSize: 14,
                                              color: "#9ca3af",
                                            }}
                                          />
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                          >
                                            {address || "N/A"}
                                            {city ? `, ${city}` : ""}
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ ml: 1 }}
                                          >
                                            • {flats.length}{" "}
                                            {flats.length === 1
                                              ? "Flat"
                                              : "Flats"}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <Tooltip title="View Details">
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleViewPropertyDetails(
                                              property,
                                              owner
                                            )
                                          }
                                        >
                                          <Visibility />
                                        </IconButton>
                                      </Tooltip>
                                      <Button
                                        size="small"
                                        variant={
                                          propertyHasPending
                                            ? "contained"
                                            : "outlined"
                                        }
                                        endIcon={
                                          expandedRows[property._id] ? (
                                            <ExpandLess />
                                          ) : (
                                            <ExpandMore />
                                          )
                                        }
                                        onClick={() =>
                                          handleExpandToggle(property._id)
                                        }
                                        sx={
                                          propertyHasPending
                                            ? {
                                                bgcolor: "#e94560",
                                                "&:hover": {
                                                  bgcolor: "#d13652",
                                                },
                                              }
                                            : { borderColor: "#e5e7eb" }
                                        }
                                      >
                                        {expandedRows[property._id]
                                          ? "Hide"
                                          : "View"}{" "}
                                        Flats
                                      </Button>
                                    </Box>
                                  </Box>

                                  {/* Flats Cards */}
                                  <Collapse in={expandedRows[property._id]}>
                                    <Box sx={{ p: 2, bgcolor: "#f1f5f9" }}>
                                      <Grid container spacing={2}>
                                        {/* Sort flats: pending first, then rejected, then approved */}
                                        {[...flats]
                                          .sort((a, b) => {
                                            const statusOrder = {
                                              pending: 0,
                                              rejected: 1,
                                              approved: 2,
                                            };
                                            const aStatus = getFlatStatus(a);
                                            const bStatus = getFlatStatus(b);
                                            return (
                                              statusOrder[aStatus] -
                                              statusOrder[bStatus]
                                            );
                                          })
                                          .map((flat, index) => {
                                            const getLeaseDuration = (
                                              value
                                            ) => {
                                              const options = {
                                                "6_months": "6 Months",
                                                "11_months": "11 Months",
                                                "1_year": "1 Year",
                                                "2_years": "2 Years",
                                                flexible: "Flexible",
                                              };
                                              return (
                                                options[value] ||
                                                value ||
                                                "11 Months"
                                              );
                                            };

                                            const flatName =
                                              flat.flatName ||
                                              flat.flat_name ||
                                              "N/A";
                                            const flatRent =
                                              flat.flatRent || flat.rent;
                                            const flatAdvance =
                                              flat.flatAdvance || 0;
                                            const flatCharges =
                                              getChargeAmounts(flat);
                                            const flatMaintananceCharges =
                                              flatCharges.maintenance;
                                            const flatTrashCharges =
                                              flatCharges.trash;
                                            const flatSecurityCharges =
                                              flatCharges.security;
                                            const flatWaterCharges =
                                              flatCharges.water;
                                            const allowedFor =
                                              flat.allowedFor || "";
                                            const rentIncrease =
                                              flat.rentIncrease || 0;
                                            const leaseDuration =
                                              getLeaseDuration(
                                                flat.leaseDuration
                                              );
                                            const rentRelaxationDays =
                                              resolveLatePolicy(flat)
                                                .gracePeriodDays;
                                            const lateFeeSummary =
                                              describeLatePolicy(
                                                resolveLatePolicy(flat)
                                              ) || "None";
                                            const flatCity =
                                              flat.city || city || "N/A";
                                            const flatFloor =
                                              (flat.flatFloor ?? flat.floor) ===
                                              0
                                                ? "Ground"
                                                : flat.flatFloor ??
                                                  flat.floor ??
                                                  "N/A";
                                            const flatRooms =
                                              flat.flatRooms ||
                                              flat.rooms ||
                                              "N/A";
                                            const flatToilet =
                                              flat.flatToilet ||
                                              flat.toilet ||
                                              flat.bathrooms ||
                                              "N/A";
                                            const flatKitchen =
                                              flat.flatKitchen ||
                                              flat.kitchen ||
                                              "N/A";
                                            const flatAddress =
                                              flat.flatAddress ||
                                              flat.propertyAddress ||
                                              address ||
                                              "N/A";
                                            const flatStatus =
                                              getFlatStatus(flat);
                                            const rejectionReason =
                                              flat.rejectionReason ||
                                              flat.rejection_reason ||
                                              "";
                                            const isRent = flat.is_rent == 1;
                                            const availabilityStatus =
                                              flat.availabilityStatus;
                                            // const uploadBill =
                                            //   flat.bill_uploaded_by || 0;

                                            // Card styles based on status
                                            const cardStyles = {
                                              pending: {
                                                border: "2px solid #fbbf24",
                                                bgcolor: "#fffbeb",
                                              },
                                              approved: {
                                                border: "1px solid #e5e7eb",
                                                bgcolor: "white",
                                              },
                                              rejected: {
                                                border: "2px solid #ef4444",
                                                bgcolor: "#fef2f2",
                                              },
                                            };

                                            return (
                                              <Grid
                                                item
                                                xs={12}
                                                key={flat._id || index}
                                              >
                                                <Card
                                                  sx={{
                                                    borderRadius: 2,
                                                    ...cardStyles[flatStatus],
                                                  }}
                                                >
                                                  <CardContent sx={{ p: 0 }}>
                                                    <Grid container>
                                                      {/* Images Section */}
                                                      <Grid item xs={12} md={4}>
                                                        <Box
                                                          sx={{
                                                            p: 2,
                                                            height: "100%",
                                                          }}
                                                        >
                                                          {flat.images?.length >
                                                          0 ? (
                                                            <Box>
                                                              {/* Main Image */}
                                                              <Box
                                                                sx={{
                                                                  position:
                                                                    "relative",
                                                                  borderRadius: 2,
                                                                  overflow:
                                                                    "hidden",
                                                                  mb: 1,
                                                                  cursor:
                                                                    "pointer",
                                                                  "&:hover .zoom-overlay":
                                                                    {
                                                                      opacity: 1,
                                                                    },
                                                                }}
                                                                onClick={() =>
                                                                  handleViewImages(
                                                                    flat.images
                                                                  )
                                                                }
                                                              >
                                                                <Box
                                                                  component="img"
                                                                  src={
                                                                    flat
                                                                      .images[0]
                                                                  }
                                                                  alt={flatName}
                                                                  sx={{
                                                                    width:
                                                                      "100%",
                                                                    height: 180,
                                                                    objectFit:
                                                                      "cover",
                                                                    borderRadius: 2,
                                                                  }}
                                                                />
                                                                <Box
                                                                  className="zoom-overlay"
                                                                  sx={{
                                                                    position:
                                                                      "absolute",
                                                                    top: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    bottom: 0,
                                                                    bgcolor:
                                                                      "rgba(0,0,0,0.5)",
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                    justifyContent:
                                                                      "center",
                                                                    opacity: 0,
                                                                    transition:
                                                                      "opacity 0.2s",
                                                                    borderRadius: 2,
                                                                  }}
                                                                >
                                                                  <ZoomIn
                                                                    sx={{
                                                                      color:
                                                                        "white",
                                                                      fontSize: 40,
                                                                    }}
                                                                  />
                                                                </Box>
                                                              </Box>
                                                              {/* Thumbnail Gallery */}
                                                              {flat.images
                                                                .length > 1 && (
                                                                <Box
                                                                  sx={{
                                                                    display:
                                                                      "flex",
                                                                    gap: 1,
                                                                    flexWrap:
                                                                      "wrap",
                                                                  }}
                                                                >
                                                                  {flat.images
                                                                    .slice(0, 4)
                                                                    .map(
                                                                      (
                                                                        img,
                                                                        imgIndex
                                                                      ) => (
                                                                        <Box
                                                                          key={
                                                                            imgIndex
                                                                          }
                                                                          sx={{
                                                                            position:
                                                                              "relative",
                                                                            cursor:
                                                                              "pointer",
                                                                            "&:hover":
                                                                              {
                                                                                opacity: 0.8,
                                                                              },
                                                                          }}
                                                                          onClick={() =>
                                                                            handleViewImages(
                                                                              flat.images
                                                                            )
                                                                          }
                                                                        >
                                                                          <Box
                                                                            component="img"
                                                                            src={
                                                                              img
                                                                            }
                                                                            alt={`${flatName} ${
                                                                              imgIndex +
                                                                              1
                                                                            }`}
                                                                            sx={{
                                                                              width: 60,
                                                                              height: 45,
                                                                              objectFit:
                                                                                "cover",
                                                                              borderRadius: 1,
                                                                              border:
                                                                                "2px solid #e5e7eb",
                                                                            }}
                                                                          />
                                                                          {imgIndex ===
                                                                            3 &&
                                                                            flat
                                                                              .images
                                                                              .length >
                                                                              4 && (
                                                                              <Box
                                                                                sx={{
                                                                                  position:
                                                                                    "absolute",
                                                                                  top: 0,
                                                                                  left: 0,
                                                                                  right: 0,
                                                                                  bottom: 0,
                                                                                  bgcolor:
                                                                                    "rgba(0,0,0,0.6)",
                                                                                  display:
                                                                                    "flex",
                                                                                  alignItems:
                                                                                    "center",
                                                                                  justifyContent:
                                                                                    "center",
                                                                                  borderRadius: 1,
                                                                                }}
                                                                              >
                                                                                <Typography
                                                                                  variant="caption"
                                                                                  sx={{
                                                                                    color:
                                                                                      "white",
                                                                                    fontWeight: 600,
                                                                                  }}
                                                                                >
                                                                                  +
                                                                                  {flat
                                                                                    .images
                                                                                    .length -
                                                                                    4}
                                                                                </Typography>
                                                                              </Box>
                                                                            )}
                                                                        </Box>
                                                                      )
                                                                    )}
                                                                </Box>
                                                              )}
                                                              <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{
                                                                  mt: 1,
                                                                  display:
                                                                    "block",
                                                                }}
                                                              >
                                                                Click to view
                                                                all{" "}
                                                                {
                                                                  flat.images
                                                                    .length
                                                                }{" "}
                                                                images
                                                              </Typography>
                                                            </Box>
                                                          ) : (
                                                            <Box
                                                              sx={{
                                                                height: 180,
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                                bgcolor:
                                                                  "#f1f5f9",
                                                                borderRadius: 2,
                                                              }}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                <ImageIcon
                                                                  sx={{
                                                                    fontSize: 48,
                                                                    color:
                                                                      "#cbd5e1",
                                                                  }}
                                                                />
                                                                <Typography
                                                                  variant="body2"
                                                                  color="text.secondary"
                                                                >
                                                                  No images
                                                                </Typography>
                                                              </Box>
                                                            </Box>
                                                          )}
                                                        </Box>
                                                      </Grid>

                                                      {/* Details Section */}
                                                      <Grid item xs={12} md={8}>
                                                        <Box sx={{ p: 2 }}>
                                                          {/* Header */}
                                                          <Box
                                                            sx={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "space-between",
                                                              alignItems:
                                                                "flex-start",
                                                              mb: 2,
                                                            }}
                                                          >
                                                            <Box>
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  mb: 0.5,
                                                                }}
                                                              >
                                                                <Typography
                                                                  variant="h6"
                                                                  sx={{
                                                                    fontWeight: 600,
                                                                  }}
                                                                >
                                                                  {flatName}
                                                                </Typography>
                                                                <Chip
                                                                  icon={
                                                                    flatStatus ===
                                                                    "approved" ? (
                                                                      <CheckCircle
                                                                        sx={{
                                                                          fontSize: 14,
                                                                        }}
                                                                      />
                                                                    ) : flatStatus ===
                                                                      "rejected" ? (
                                                                      <Cancel
                                                                        sx={{
                                                                          fontSize: 14,
                                                                        }}
                                                                      />
                                                                    ) : (
                                                                      <HourglassEmpty
                                                                        sx={{
                                                                          fontSize: 14,
                                                                        }}
                                                                      />
                                                                    )
                                                                  }
                                                                  label={
                                                                    flatStatus ===
                                                                    "approved"
                                                                      ? "Approved"
                                                                      : flatStatus ===
                                                                        "rejected"
                                                                      ? "Rejected"
                                                                      : "Pending"
                                                                  }
                                                                  size="small"
                                                                  sx={{
                                                                    bgcolor:
                                                                      flatStatus ===
                                                                      "approved"
                                                                        ? "#dcfce7"
                                                                        : flatStatus ===
                                                                          "rejected"
                                                                        ? "#fee2e2"
                                                                        : "#fef3c7",
                                                                    color:
                                                                      flatStatus ===
                                                                      "approved"
                                                                        ? "#166534"
                                                                        : flatStatus ===
                                                                          "rejected"
                                                                        ? "#dc2626"
                                                                        : "#92400e",
                                                                    "& .MuiChip-icon":
                                                                      {
                                                                        color:
                                                                          "inherit",
                                                                      },
                                                                  }}
                                                                />
                                                              </Box>
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 0.5,
                                                                }}
                                                              >
                                                                <LocationOn
                                                                  sx={{
                                                                    fontSize: 16,
                                                                    color:
                                                                      "#9ca3af",
                                                                  }}
                                                                />
                                                                <Typography
                                                                  variant="body2"
                                                                  color="text.secondary"
                                                                >
                                                                  {flatAddress},{" "}
                                                                  {flatCity}
                                                                </Typography>
                                                              </Box>
                                                            </Box>
                                                            <Box
                                                              sx={{
                                                                textAlign:
                                                                  "right",
                                                              }}
                                                            >
                                                              <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                              >
                                                                Monthly Rent
                                                              </Typography>
                                                              <Typography
                                                                variant="h5"
                                                                sx={{
                                                                  fontWeight: 700,
                                                                  color:
                                                                    "#22c55e",
                                                                }}
                                                              >
                                                                Rs.{" "}
                                                                {flatRent?.toLocaleString() ||
                                                                  "N/A"}
                                                              </Typography>
                                                            </Box>
                                                          </Box>

                                                          {/* Property Details Grid */}
                                                          <Grid
                                                            container
                                                            spacing={2}
                                                            sx={{ mb: 2 }}
                                                          >
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <Layers
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Floor
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {flatFloor}
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <MeetingRoom
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#e94560",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Rooms
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {flatRooms}
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <Bathroom
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#0ea5e9",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Toilet
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {flatToilet}
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <Kitchen
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#f59e0b",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Kitchen
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      flatKitchen
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>

                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <AccountBalanceWalletIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Advance
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      flatAdvance
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <BuildIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Maintenance
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      flatMaintananceCharges
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <DeleteIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Trash
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      flatTrashCharges
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <SecurityIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Security
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      flatSecurityCharges
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <SecurityIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Water
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      flatWaterCharges
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <GroupIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Allowed For
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {allowedFor}
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <TrendingUpIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Rent
                                                                    Increase
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      rentIncrease
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <EventIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Lease
                                                                    Duration
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      leaseDuration
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <BeachAccessIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Relaxation
                                                                    Days
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      rentRelaxationDays
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <WarningAmberIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Late Charges
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      lateFeeSummary
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <WarningAmberIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Occupied
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {isRent
                                                                      ? "Yes"
                                                                      : "No"}
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <WarningAmberIcon
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Availability
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {availabilityStatus
                                                                      ? "Available"
                                                                      : "Not Available"}
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid>
                                                            {/* <Grid
                                                              item
                                                              xs={6}
                                                              sm={3}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  gap: 1,
                                                                  p: 1.5,
                                                                  bgcolor:
                                                                    "#f8fafc",
                                                                  borderRadius: 1,
                                                                }}
                                                              >
                                                                <UploadFile
                                                                  sx={{
                                                                    fontSize: 20,
                                                                    color:
                                                                      "#6366f1",
                                                                  }}
                                                                />
                                                                <Box>
                                                                  <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                  >
                                                                    Upload Bill
                                                                  </Typography>
                                                                  <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                      fontWeight: 600,
                                                                    }}
                                                                  >
                                                                    {
                                                                      uploadBill==="landlord"?"Owner":"Tenant"
                                                                    }
                                                                  </Typography>
                                                                </Box>
                                                              </Box>
                                                            </Grid> */}
                                                          </Grid>
                                                          {/* jjjjjjjjj */}

                                                          {/* Amenities Section */}
                                                          <Grid
                                                            container
                                                            spacing={1}
                                                          >
                                                            {(() => {
                                                              const getAllAmenities =
                                                                (flat) => {
                                                                  const amenityList =
                                                                    [
                                                                      {
                                                                        key: "balcony",
                                                                        label:
                                                                          "Balcony",
                                                                        icon: (
                                                                          <BalconyIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.balcony ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "bathTub",
                                                                        label:
                                                                          "Bath Tub",
                                                                        icon: (
                                                                          <BathtubIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.bathTub ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "pool",
                                                                        label:
                                                                          "Pool",
                                                                        icon: (
                                                                          <PoolIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.pool ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "gym",
                                                                        label:
                                                                          "Gym",
                                                                        icon: (
                                                                          <FitnessCenterIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.gym ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "wifi",
                                                                        label:
                                                                          "WiFi",
                                                                        icon: (
                                                                          <WifiIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.wifi ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "parkingAvailable",
                                                                        label:
                                                                          "Parking",
                                                                        icon: (
                                                                          <LocalParkingIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.parkingAvailable ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "elevator",
                                                                        label:
                                                                          "Elevator",
                                                                        icon: (
                                                                          <ElevatorIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.elevator ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "furnished",
                                                                        label:
                                                                          "Furnished",
                                                                        icon: (
                                                                          <WeekendIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.furnished ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "petAllowed",
                                                                        label:
                                                                          "Pet Allowed",
                                                                        icon: (
                                                                          <PetsIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.petAllowed ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "roof",
                                                                        label:
                                                                          "Roof Access",
                                                                        icon: (
                                                                          <RoofingIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.roof ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "fireExtinguisher",
                                                                        label:
                                                                          "Fire Extinguisher",
                                                                        icon: (
                                                                          <FireExtinguisherIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.fireExtinguisher ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "smokeAlarm",
                                                                        label:
                                                                          "Smoke Alarm",
                                                                        icon: (
                                                                          <AlarmIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.smokeAlarm ===
                                                                          "true",
                                                                      },
                                                                      {
                                                                        key: "firstAidKit",
                                                                        label:
                                                                          "First Aid Kit",
                                                                        icon: (
                                                                          <LocalHospitalIcon
                                                                            sx={{
                                                                              fontSize: 16,
                                                                            }}
                                                                          />
                                                                        ),
                                                                        value:
                                                                          flat.firstAidKit ===
                                                                          "true",
                                                                      },
                                                                    ];
                                                                  return amenityList.filter(
                                                                    (amenity) =>
                                                                      amenity.value
                                                                  );
                                                                };

                                                              const trueAmenities =
                                                                getAllAmenities(
                                                                  flat
                                                                );
                                                              const visibleAmenities =
                                                                showAllAmenities
                                                                  ? trueAmenities
                                                                  : trueAmenities.slice(
                                                                      0,
                                                                      3
                                                                    );
                                                              const remainingCount =
                                                                trueAmenities.length -
                                                                3;

                                                              return (
                                                                <>
                                                                  {visibleAmenities.map(
                                                                    (item) => (
                                                                      <Grid
                                                                        item
                                                                        key={
                                                                          item.key
                                                                        }
                                                                        sx={{
                                                                          mb: 2,
                                                                        }}
                                                                      >
                                                                        <Tooltip
                                                                          title={
                                                                            item.label
                                                                          }
                                                                        >
                                                                          <Chip
                                                                            icon={
                                                                              item.icon
                                                                            }
                                                                            label={
                                                                              item.label
                                                                            }
                                                                            size="small"
                                                                            sx={{
                                                                              fontWeight: 500,
                                                                              bgcolor:
                                                                                "#e0f2fe",
                                                                              color:
                                                                                "#0369a1",
                                                                              "& .MuiChip-icon":
                                                                                {
                                                                                  color:
                                                                                    "#0369a1",
                                                                                },
                                                                            }}
                                                                          />
                                                                        </Tooltip>
                                                                      </Grid>
                                                                    )
                                                                  )}

                                                                  {remainingCount >
                                                                    0 && (
                                                                    <Grid item>
                                                                      <Chip
                                                                        label={
                                                                          showAllAmenities
                                                                            ? "Show Less"
                                                                            : `+${remainingCount} more`
                                                                        }
                                                                        size="small"
                                                                        onClick={() =>
                                                                          setShowAllAmenities(
                                                                            !showAllAmenities
                                                                          )
                                                                        }
                                                                        sx={{
                                                                          bgcolor:
                                                                            "#f1f5f9",
                                                                          color:
                                                                            "#475569",
                                                                          fontWeight: 500,
                                                                          cursor:
                                                                            "pointer",
                                                                          "&:hover":
                                                                            {
                                                                              bgcolor:
                                                                                "#e2e8f0",
                                                                            },
                                                                        }}
                                                                      />
                                                                    </Grid>
                                                                  )}
                                                                </>
                                                              );
                                                            })()}
                                                          </Grid>

                                                          {/* Action Buttons for Pending */}
                                                          {flatStatus ===
                                                            "pending" && flat?.is_property_settings  && (
                                                            <Box
                                                              sx={{
                                                                display: "flex",
                                                                justifyContent:
                                                                  "flex-end",
                                                                gap: 2,
                                                              }}
                                                            >
                                                              <Button
                                                                variant="outlined"
                                                                color="error"
                                                                startIcon={
                                                                  actionLoading ===
                                                                  flat._id ? (
                                                                    <CircularProgress
                                                                      size={16}
                                                                      color="inherit"
                                                                    />
                                                                  ) : (
                                                                    <ThumbDown />
                                                                  )
                                                                }
                                                                onClick={() =>
                                                                  handleOpenRejectDialog(
                                                                    flat
                                                                  )
                                                                }
                                                                disabled={
                                                                  actionLoading ===
                                                                  flat._id
                                                                }
                                                                sx={{ px: 3 }}
                                                              >
                                                                Reject
                                                              </Button>
                                                              <Button
                                                                variant="contained"
                                                                startIcon={
                                                                  actionLoading ===
                                                                  flat._id ? (
                                                                    <CircularProgress
                                                                      size={16}
                                                                      color="inherit"
                                                                    />
                                                                  ) : (
                                                                    <ThumbUp />
                                                                  )
                                                                }
                                                                onClick={() =>
                                                                  handleApproveFlat(
                                                                    flat
                                                                  )
                                                                }
                                                                disabled={
                                                                  actionLoading ===
                                                                  flat._id
                                                                }
                                                                sx={{
                                                                  bgcolor:
                                                                    "#22c55e",
                                                                  "&:hover": {
                                                                    bgcolor:
                                                                      "#16a34a",
                                                                  },
                                                                  px: 3,
                                                                }}
                                                              >
                                                                Approve
                                                              </Button>
                                                            </Box>
                                                          )}

                                                          {/* Rejection Reason for Rejected Flats */}
                                                          {flatStatus ===
                                                            "rejected" &&
                                                            rejectionReason && (
                                                              <Box
                                                                sx={{
                                                                  mt: 2,
                                                                  p: 2,
                                                                  bgcolor:
                                                                    "#fef2f2",
                                                                  borderRadius: 2,
                                                                  border:
                                                                    "1px solid #fecaca",
                                                                }}
                                                              >
                                                                <Typography
                                                                  variant="subtitle2"
                                                                  sx={{
                                                                    color:
                                                                      "#dc2626",
                                                                    fontWeight: 600,
                                                                    mb: 0.5,
                                                                  }}
                                                                >
                                                                  Rejection
                                                                  Reason:
                                                                </Typography>
                                                                <Typography
                                                                  variant="body2"
                                                                  color="text.secondary"
                                                                >
                                                                  {
                                                                    rejectionReason
                                                                  }
                                                                </Typography>
                                                              </Box>
                                                            )}
                                                        </Box>
                                                      </Grid>
                                                    </Grid>
                                                  </CardContent>
                                                </Card>
                                              </Grid>
                                            );
                                          })}
                                      </Grid>
                                    </Box>
                                  </Collapse>
                                </Paper>
                              );
                            });
                        })()}
                      </Box>
                    </Collapse>
                  </Paper>
                );
              })
            )}
          </>
        )}

        {/* Property Details Dialog */}
        <Dialog
          open={detailsOpen}
          onClose={() => setDetailsOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Property Details
            </Typography>
            <IconButton onClick={() => setDetailsOpen(false)}>
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {selectedProperty &&
              (() => {
                const dialogFlats = getFlats(selectedProperty);
                const dialogOwnerName =
                  selectedProperty.ownerName ||
                  selectedProperty.owner_name ||
                  "N/A";
                const dialogOwnerEmail = selectedProperty.email || "N/A";
                const dialogOwnerContact =
                  selectedProperty.contactNumber ||
                  selectedProperty.contact ||
                  selectedProperty.phone ||
                  "N/A";
                const dialogFirstFlat = dialogFlats[0] || {};
                const dialogAddress =
                  dialogFirstFlat.propertyAddress ||
                  dialogFirstFlat.flatAddress ||
                  selectedProperty.address ||
                  "N/A";
                const dialogCity =
                  dialogFirstFlat.city || selectedProperty.city || "N/A";
                const pendingFlatsCount =
                  dialogFlats.filter((f) => !f.is_approved && !f.isApproved)
                    ?.length || 0;
                const dialogSignature =
                  selectedProperty.signature ||
                  selectedProperty.signature ||
                  "N/A";
                const dialogCNICFront =
                  selectedProperty.cnicFront ||
                  selectedProperty.cnicFront ||
                  "N/A";
                const dialogCNICBack =
                  selectedProperty.cnicBack ||
                  selectedProperty.cnicBack ||
                  "N/A";
                return (
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Person sx={{ fontSize: 20, color: "#e94560" }} />
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Owner Name
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500 }}
                            >
                              {dialogOwnerName}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Email sx={{ fontSize: 20, color: "#6366f1" }} />
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Email
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500 }}
                            >
                              {dialogOwnerEmail}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Phone sx={{ fontSize: 20, color: "#22c55e" }} />
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Contact Number
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500 }}
                            >
                              {dialogOwnerContact}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <LocationOn sx={{ fontSize: 20, color: "#e94560" }} />
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Address
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500 }}
                            >
                              {dialogAddress}, {dialogCity}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Apartment sx={{ fontSize: 20, color: "#3730a3" }} />
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Total Flats
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500 }}
                            >
                              {dialogFlats.length}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <HourglassEmpty
                            sx={{ fontSize: 20, color: "#d97706" }}
                          />
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Pending Flats
                            </Typography>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500 }}
                            >
                              {pendingFlatsCount}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      {selectedProperty?.propertyDetail?.[0]?.lat && (
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              border: "1px solid",
                              borderColor: "divider",
                              borderRadius: 2,
                              p: 2,
                            }}
                          >
                            {/* Header */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <LocationOn
                                sx={{ fontSize: 20, color: "#e94560" }}
                              />
                              <Box>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Property Location
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {selectedProperty?.propertyDetail?.[0]
                                    ?.propertyAddress ||
                                    "Location not available"}
                                </Typography>
                              </Box>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<MapIcon />}
                                onClick={() => {
                                  window.open(
                                    `https://www.google.com/maps?q=${selectedProperty?.propertyDetail?.[0]?.lat},${selectedProperty?.propertyDetail?.[0]?.lng}`,
                                    "_blank"
                                  );
                                }}
                                sx={{
                                  textTransform: "none",
                                  whiteSpace: "nowrap",
                                  minWidth: "auto",
                                }}
                              >
                                Open in Google Maps
                              </Button>
                            </Box>

                            {/* Map */}
                            <MapContainer
                              key={
                                selectedProperty?.propertyDetail?.[0]?.lat +
                                selectedProperty?.propertyDetail?.[0]?.lng
                              }
                              center={[
                                Number(
                                  selectedProperty?.propertyDetail?.[0].lat
                                ),
                                Number(
                                  selectedProperty?.propertyDetail?.[0].lng
                                ),
                              ]}
                              zoom={14}
                              style={{
                                height: 260,
                                width: "100%",
                                borderRadius: 8,
                              }}
                            >
                              <TileLayer
                                attribution="&copy; OpenStreetMap contributors"
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              />

                              <Marker
                                position={[
                                  Number(
                                    selectedProperty?.propertyDetail?.[0].lat
                                  ),
                                  Number(
                                    selectedProperty?.propertyDetail?.[0].lng
                                  ),
                                ]}
                              />
                            </MapContainer>
                          </Box>
                        </Grid>
                      )}
                    </Grid>

                    <Divider sx={{ my: 3 }} />

                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2 }}
                    >
                      Flats ({dialogFlats.length})
                    </Typography>

                    <Grid container spacing={2}>
                      {dialogFlats.map((flat, index) => {
                        const dialogFlatName =
                          flat.flatName || flat.flat_name || "N/A";
                        const dialogFlatRent = flat.flatRent || flat.rent;
                        const dialogFlatApproved =
                          flat.is_approved || flat.isApproved;

                        return (
                          <Grid item xs={12} sm={6} key={flat._id || index}>
                            <Card variant="outlined" sx={{ borderRadius: 2 }}>
                              {flat.images?.[0] && (
                                <CardMedia
                                  component="img"
                                  height="140"
                                  image={flat.images[0]}
                                  alt={dialogFlatName}
                                  onClick={() => handleViewImages(flat.images)}
                                  sx={{ cursor: "pointer" }}
                                />
                              )}
                              <CardContent sx={{ py: 2 }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 1,
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: 600 }}
                                  >
                                    {dialogFlatName}
                                  </Typography>
                                  <Chip
                                    size="small"
                                    label={
                                      dialogFlatApproved
                                        ? "Approved"
                                        : "Pending"
                                    }
                                    sx={{
                                      bgcolor: dialogFlatApproved
                                        ? "#dcfce7"
                                        : "#fef3c7",
                                      color: dialogFlatApproved
                                        ? "#166534"
                                        : "#92400e",
                                    }}
                                  />
                                </Box>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Rent: Rs.{" "}
                                  {dialogFlatRent?.toLocaleString() || "N/A"}
                                </Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                    <Divider sx={{ my: 3 }} />

                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2 }}
                    >
                      Owner Verification
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Card variant="outlined" sx={{ borderRadius: 2 }}>
                          {dialogSignature && (
                            <CardMedia
                              component="img"
                              height="140"
                              image={dialogSignature}
                              alt={dialogSignature}
                              onClick={() =>
                                handleViewImages([dialogSignature])
                              }
                              sx={{ cursor: "pointer" }}
                            />
                          )}
                        </Card>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Card variant="outlined" sx={{ borderRadius: 2 }}>
                          {dialogCNICFront && (
                            <CardMedia
                              component="img"
                              height="140"
                              image={dialogCNICFront}
                              alt={dialogCNICFront}
                              onClick={() =>
                                handleViewImages([dialogCNICFront])
                              }
                              sx={{ cursor: "pointer" }}
                            />
                          )}
                        </Card>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Card variant="outlined" sx={{ borderRadius: 2 }}>
                          {dialogCNICBack && (
                            <CardMedia
                              component="img"
                              height="140"
                              image={dialogCNICBack}
                              alt={dialogCNICBack}
                              onClick={() => handleViewImages([dialogCNICBack])}
                              sx={{ cursor: "pointer" }}
                            />
                          )}
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                );
              })()}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setDetailsOpen(false)} variant="outlined">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Image Zoom Modal */}
        <ImageZoomModal
          open={imageModalOpen}
          onClose={() => setImageModalOpen(false)}
          images={selectedImages}
        />

        {/* Reject Confirmation Dialog */}
        <Dialog
          open={rejectDialog.open}
          onClose={handleCloseRejectDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: "#dc2626",
            }}
          >
            <Block sx={{ color: "#dc2626" }} />
            Reject Property
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              You are about to reject "
              <strong>
                {rejectDialog.flat?.flatName ||
                  rejectDialog.flat?.flat_name ||
                  "this flat"}
              </strong>
              ". Please provide a reason for rejection so the owner can make
              necessary changes.
            </Typography>

            <TextField
              fullWidth
              multiline
              rows={4}
              label="Rejection Reason"
              placeholder="Enter the reason for rejecting this property..."
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              error={!rejectReason.trim() && rejectReason !== ""}
              helperText={
                !rejectReason.trim() && rejectReason !== ""
                  ? "Please provide a reason"
                  : ""
              }
              sx={{ mt: 1 }}
            />

            <FormControlLabel
              sx={{ mt: 1 }}
              control={
                <Checkbox
                  checked={signatureIssue}
                  onChange={(e) => setSignatureIssue(e.target.checked)}
                  color="error"
                />
              }
              label="Signature / CNIC issue"
            />
          </DialogContent>

          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button onClick={handleCloseRejectDialog} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleRejectFlat}
              variant="contained"
              color="error"
              disabled={!rejectReason.trim()}
              startIcon={<ThumbDown />}
            >
              Reject Property
            </Button>
          </DialogActions>
        </Dialog>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="colored"
        />
      </Box>
    </>
  );
};

export default PropertyManagement;
